import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FlashMessagesService } from 'src/app/shared/services/flash-messages.service';
import {
  ANIMATE_CLASS_ACTIVE,
  ANIMATE_CLASS_INACTIVE,
} from '../../../core/constants/consts';
import { SpinnerService } from '../../../shared/components/spinner/spinner.service';
import { MessagesPipe } from '../../../shared/pipes/messages.pipe';
import { ResourcesService } from '../../../shared/services/resources.service';
import { slideButtons } from '../../../shared/utils/reservation.list.animations';
import { SideModalService } from '../../side-modal/side-modal.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  animations: [slideButtons()],
})
export class ListComponent implements OnInit {
  resourceList = [];
  resourceHistoryList = [];
  showOptionsButtons: boolean = false;

  showReserveForm = false;
  dataEdit = null;
  ie: boolean;

  messagesPipe = new MessagesPipe();
  constructor(
    private resourcesService: ResourcesService,
    private flashMessagesService: FlashMessagesService,
    private spinnerService: SpinnerService,
    private sideModalService: SideModalService,
    private route: ActivatedRoute
  ) {
    this.showOptionsButtons = false;
    this.ie = false;
  }

  ngOnInit(): void {
    let userAgent: string, ieReg: RegExp;
    userAgent = window.navigator.userAgent;
    ieReg = /msie|Trident.*rv[ :]*11\./gi;
    this.ie = ieReg.test(userAgent);
    this.getResourceForHour();
    this.getResourceForHourMe();
    this.closeReserve();
  }

  showButtons(): void {
    this.showOptionsButtons = !this.showOptionsButtons;
  }

  getResourceForHour() {
    this.resourcesService.getResourceForHour().subscribe(
      (res) => {
        if (res?.content) {
          this.resourceHistoryList = res?.content;
        } else {
          this.resourceHistoryList = [];
        }
      },
      () => {
        this.resourceHistoryList = [];
      }
    );
  }

  getResourceForHourMe() {
    this.resourcesService.getResourceForHourReservationMe().subscribe(
      (res) => {
        if (res?.content) {
          this.resourceList = res?.content;
        } else {
          this.resourceList = [];
        }
      },
      () => {
        this.resourceList = [];
      }
    );
  }

  cancelResourceForHourReservation(resourceForHourReservationId: number) {
    this.spinnerService.show();
    this.resourcesService
      .cancelResourceForHourReservation(resourceForHourReservationId)
      .subscribe(
        (res) => {
          this.getResourceForHourMe();
          this.flashMessagesService.show(
            this.messagesPipe.transform('resource_list_cancel_reservation_ok'),
            {
              cssClass: 'alert-success',
              timeout: 3000,
            }
          );
          this.spinnerService.hide();
        },
        () => {
          this.flashMessagesService.show(
            this.messagesPipe.transform(
              'resource_list_cancel_reservation_error'
            ),
            {
              cssClass: 'alert-success',
              timeout: 3000,
            }
          );
          this.spinnerService.hide();
        }
      );
  }

  editResourceForHourReservation(data) {
    this.dataEdit = data;
    this.sideModalService.openSideModal(
      'reserve',
      { dataEdit: this.dataEdit },
      this.messagesPipe.transform('resource_edit_title'),
      this.route,
      true
    );
  }

  openReserve() {
    this.sideModalService.openSideModal(
      'reserve',
      {},
      this.messagesPipe.transform('resource_reserve_title'),
      this.route,
      false
    );
  }

  closeReserve() {
    this.sideModalService.subjectSideModal(this.route).subscribe((res) => {
      if (res.close && res.nameComponent) {
        this.showOptionsButtons = false;
        this.getResourceForHourMe();
      }
    });
  }

  getSlideButtonsClass(): string {
    if (this.ie) {
      const el = document.getElementById('resource-list');
      if (this.showOptionsButtons) {
        el.style.display = 'block';
        el.style.opacity = '1';
      } else {
        el.style.display = 'none';
        el.style.opacity = '0';
      }
    } else {
      if (this.showOptionsButtons) {
        return ANIMATE_CLASS_ACTIVE;
      } else {
        return ANIMATE_CLASS_INACTIVE;
      }
    }
  }
}
